/// <reference no-default-lib="true" />
/// <reference lib="esnext" />
/// <reference lib="dom" />

export function initSearches() {
  const searches = Array.from(
    document.querySelectorAll('.search'),
  ) as HTMLElement[]

  for (const search of searches) {
    if (search.dataset.hydrated) continue
    search.dataset.hydrated = 'true'
    search.addEventListener('set-loading', () => {
      search.classList.add('search--loading')
    })

    search.addEventListener('unset-loading', () => {
      search.classList.remove('search--loading')
    })
  }
}
